import { render, staticRenderFns } from "./TprepAdminDashboard.vue?vue&type=template&id=23974910&scoped=true"
import script from "./TprepAdminDashboard.vue?vue&type=script&lang=js"
export * from "./TprepAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./TprepAdminDashboard.vue?vue&type=style&index=0&id=23974910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23974910",
  null
  
)

export default component.exports